export const DEFAULT_BRANDING = {
  logo_url: '/images/tda-logo.png',
  site_title: 'Tanzania Dental Association',
  site_tagline: 'Conference & World Oral Health Week Portal',
  primary_color: '#0056B3',
  primary_dark_color: '#003d80',
};

export const DEFAULT_HERO_CTAS = [
  {
    id: 'register',
    label: 'Register for Conference',
    path: '/register',
    style: 'primary',
  },
  {
    id: 'conference',
    label: 'Visit Conference Site',
    path: '/conference',
    style: 'secondary',
  },
  {
    id: 'wohd',
    label: 'Explore WOHD',
    path: '/wohd',
    style: 'secondary',
  },
];

export const DEFAULT_CONFERENCE_TERTIARY_LINKS = [
  { label: 'Submit Abstract', path: '/abstracts' },
  { label: 'Packages', path: '/packages' },
  { label: 'Exhibitor registration', path: '/register/exhibitor' },
  { label: 'Accommodation', path: '/accommodation' },
];

export const DEFAULT_HOMEPAGE = {
  hero_title: 'Tanzania Dental Association',
  hero_subtitle: 'Two flagship events. One shared mission: advancing oral health for all.',
  hero_image_url: '',
  hero_ctas: DEFAULT_HERO_CTAS,
  about_title: 'Tanzania Dental Association (TDA)',
  about_text:
    'An Association of Oral health professional personnel in Tanzania. It was registered in Tanzania on the 2nd of April 1980, and its registration number is SO. 6167.',
  about_welcome:
    'Welcome to the Tanzania Dental Association (TDA) website. TDA is the home of oral health professionals in Tanzania, committed to advancing dentistry, supporting our members, and promoting oral health for all.',
  president_name: 'Dr. Gemma Berege',
  president_title: 'President',
  what_we_do_title: 'What do we do?',
  what_we_do_cards: [
    {
      id: 'profession',
      icon: 'briefcase',
      title: 'For the Profession',
      text: 'We empower dentists through scientific conferences, CPD, and networking.',
      style: 'profession',
    },
    {
      id: 'oral',
      icon: 'heart',
      title: 'Oral Health Promotion',
      text: 'We raise awareness and provide outreach to improve community oral health.',
      style: 'oral',
    },
    {
      id: 'education',
      icon: 'book',
      title: 'Education & Research',
      text: 'We support dental training and share knowledge through research.',
      style: 'education',
    },
    {
      id: 'partnerships',
      icon: 'handshake',
      title: 'Partnerships & Advocacy',
      text: 'We collaborate with stakeholders and influence policies to strengthen oral health care.',
      style: 'partnerships',
    },
  ],
  event_cards: [
    {
      id: 'conference',
      badge: 'Conference',
      badge_style: 'conference',
      title: '41st TDA Scientific Conference & AGM 2026',
      meta: '📅 25–27 November 2026 · 📍 Katavi Region, Tanzania',
      description:
        'The premier national gathering for dental professionals, researchers, and industry partners, featuring scientific sessions, exhibitions, and networking.',
      primary_label: 'Visit Conference Site',
      primary_path: '/conference',
      secondary_label: 'Register for Conference',
      secondary_path: '/register',
      card_style: 'conference',
      tertiary_links: DEFAULT_CONFERENCE_TERTIARY_LINKS,
    },
    {
      id: 'wohd',
      badge: 'WOHD',
      badge_style: 'wohd',
      title: 'World Oral Health Week Outreach 2026',
      meta: '📅 14–20 March 2026 · 📍 Manyara Region, Tanzania',
      description:
        'A week-long community outreach bringing oral health services, education, and awareness to communities across the host region.',
      primary_label: 'Visit WOHD Site',
      primary_path: '/wohd',
      secondary_label: 'Register as Participant',
      secondary_path: '/wohd/register',
      card_style: 'wohd',
    },
  ],
};

export const DEFAULT_NEWS = {
  section_title: 'Latest News & Updates',
  section_subtitle: 'Stay informed about the latest conference announcements and important dates',
  items: [
    {
      id: 'news-1',
      title: 'Early Bird Registration Now Open',
      date: '2026-01-15',
      excerpt:
        'Register before September 26, 2026 to take advantage of early bird pricing and secure your spot at the conference.',
      category: 'Registration',
      visible: true,
      order: 0,
    },
    {
      id: 'news-2',
      title: 'Call for Abstracts',
      date: '2026-01-10',
      excerpt:
        'Conference abstracts are invited for 25–27 November 2026 in Katavi. Deadline for submission is 30 October 2026. Submit your research today!',
      category: 'Abstracts',
      visible: true,
      order: 1,
    },
    {
      id: 'news-3',
      title: 'Keynote Speakers Announced',
      date: '2026-01-05',
      excerpt:
        'We are excited to announce our lineup of distinguished keynote speakers from around the world.',
      category: 'Speakers',
      visible: true,
      order: 2,
    },
  ],
};

/** Top-level nav items; children = dropdown links */
export const DEFAULT_NAVIGATION = [
  {
    id: 'nav-home',
    label: 'Home',
    path: '/',
    visible: true,
    order: 0,
    nav_group: null,
    children: [],
  },
  {
    id: 'nav-wohd',
    label: 'WOHD',
    path: '/wohd',
    visible: true,
    order: 1,
    nav_group: 'wohd',
    children: [
      { id: 'wohd-overview', label: 'Overview', path: '/wohd', visible: true, order: 0 },
      { id: 'wohd-register', label: 'Register', path: '/wohd/register', visible: true, order: 1 },
      { id: 'wohd-programs', label: 'Programs', path: '/wohd/programs', visible: true, order: 2 },
      { id: 'wohd-accommodation', label: 'Accommodation', path: '/wohd/accommodation', visible: true, order: 3 },
      { id: 'wohd-poster', label: 'Poster', path: '/wohd/poster', visible: true, order: 4 },
      { id: 'wohd-supporters', label: 'Supporters', path: '/wohd/supporters', visible: true, order: 5 },
    ],
  },
  {
    id: 'nav-conference',
    label: 'Conference',
    path: '/conference',
    visible: true,
    order: 2,
    nav_group: 'conference',
    children: [
      { id: 'conf-register', label: 'Register', path: '/register', visible: true, order: 0 },
      { id: 'conf-abstracts', label: 'Submit Abstract', path: '/abstracts', visible: true, order: 1 },
      { id: 'conf-packages', label: 'Packages', path: '/packages', visible: true, order: 2 },
      { id: 'conf-exhibitor', label: 'Exhibitor registration', path: '/register/exhibitor', visible: true, order: 3 },
      { id: 'conf-accommodation', label: 'Accommodation', path: '/accommodation', visible: true, order: 4 },
      { id: 'conf-speakers', label: 'Speakers, Gallery & Tourism', path: '/speakers', visible: true, order: 5 },
      { id: 'conf-poster', label: 'Create Poster', path: '/poster', visible: true, order: 6 },
    ],
  },
  {
    id: 'nav-contact',
    label: 'Contact',
    path: '/leadership',
    visible: true,
    order: 3,
    nav_group: null,
    children: [],
  },
  {
    id: 'nav-directory',
    label: 'Directory',
    path: '/directory',
    visible: true,
    order: 4,
    nav_group: null,
    children: [],
  },
];

export const WHAT_WE_DO_ICONS = {
  briefcase: '\u{1F4BC}',
  heart: '\u2665',
  book: '\u{1F4D6}',
  handshake: '\u{1F91D}',
};
